// extracted by mini-css-extract-plugin
export default {"container":"VideoCapturePage_container__hrsay","error-message":"VideoCapturePage_error-message__u+SWG"};